import { render, staticRenderFns } from "./editpaypwd.vue?vue&type=template&id=16dab608&scoped=true"
import script from "./editpaypwd.vue?vue&type=script&lang=js"
export * from "./editpaypwd.vue?vue&type=script&lang=js"
import style0 from "./editpaypwd.vue?vue&type=style&index=0&id=16dab608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dab608",
  null
  
)

export default component.exports